/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum PaymentsServiceSwitchQuoteInvoiceAdjustmentType {
  NoAdjustment = "NoAdjustment",
  AdditionalCharge = "AdditionalCharge",
  IncreaseIssuedShipmentInvoice = "IncreaseIssuedShipmentInvoice",
  ReduceOrRefundShipmentInvoice = "ReduceOrRefundShipmentInvoice",
}

export function instanceOfPaymentsServiceSwitchQuoteInvoiceAdjustmentType(
  value: any,
): boolean {
  for (const key in PaymentsServiceSwitchQuoteInvoiceAdjustmentType) {
    if (
      Object.prototype.hasOwnProperty.call(
        PaymentsServiceSwitchQuoteInvoiceAdjustmentType,
        key,
      )
    ) {
      if (
        PaymentsServiceSwitchQuoteInvoiceAdjustmentType[
          key as keyof typeof PaymentsServiceSwitchQuoteInvoiceAdjustmentType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function PaymentsServiceSwitchQuoteInvoiceAdjustmentTypeFromJSON(
  json: any,
): PaymentsServiceSwitchQuoteInvoiceAdjustmentType {
  return PaymentsServiceSwitchQuoteInvoiceAdjustmentTypeFromJSONTyped(
    json,
    false,
  );
}

export function PaymentsServiceSwitchQuoteInvoiceAdjustmentTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaymentsServiceSwitchQuoteInvoiceAdjustmentType {
  return json as PaymentsServiceSwitchQuoteInvoiceAdjustmentType;
}

export function PaymentsServiceSwitchQuoteInvoiceAdjustmentTypeToJSON(
  value?: PaymentsServiceSwitchQuoteInvoiceAdjustmentType | null,
): any {
  return value as any;
}

export function PaymentsServiceSwitchQuoteInvoiceAdjustmentTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): PaymentsServiceSwitchQuoteInvoiceAdjustmentType {
  return value as PaymentsServiceSwitchQuoteInvoiceAdjustmentType;
}
